import { ProfileCertificationTypeDto } from './dto/profile-certification-type.dto';
import { ApiService, ApiCacheOptions } from 'src/app/shared';
import { Injectable } from '@angular/core';
import { ProfileServiceApiService } from 'src/app/shared/api/profile-service-api.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileCertificationService {
  constructor(private _apiService: ApiService, private _profileServiceApiService: ProfileServiceApiService) {}

  public getProfileCertifications(profileId: number) {
    let noCache = new ApiCacheOptions();
    noCache.CacheSeconds = 0;
    noCache.DeleteCache = true;
    noCache.DisableCaching = true;
    noCache.DisableSlidingCache = true;

    return this._profileServiceApiService.get(`profile/v2/${profileId}/certifications`, noCache);
  }

  public create(cert: ProfileCertificationTypeDto) {
    return this._apiService.post(`Profiles/Certifications/Types`, cert);
  }

  public update(cert: ProfileCertificationTypeDto) {
    return this._apiService.put(`Profiles/Certifications/Type/${cert.ProfileCertificationTypeID}`, cert);
  }

  public delete(certId: number) {
    return this._apiService.delete(`Profiles/Certifications/Type/${certId}`);
  }

  public renewCertification(certId: number) {
    return this._apiService.put(`Profiles/Certifications/Type/${certId}/Recertify`, certId);
  }
}
